module.exports = __webpack_public_path__ + "static/media/alsaha_thumb.10b52e9f.jpg";